import { defineComponent as _defineComponent } from 'vue'
import { normalizeClass as _normalizeClass, createVNode as _createVNode, unref as _unref, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, createElementVNode as _createElementVNode, vShow as _vShow, withDirectives as _withDirectives, Transition as _Transition, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "sm-notify" }
const _hoisted_2 = { class: "sm-notify__header" }
const _hoisted_3 = {
  key: 0,
  class: "sm-notify__title"
}
const _hoisted_4 = ["innerHTML"]
const _hoisted_5 = {
  key: 1,
  class: "sm-notify__text"
}

import {
  ref,
  onMounted,
  toRefs,
  computed,
  onUnmounted,
} from 'vue';

// Types
import { INotifyProps } from '@/types/components/notify';
import { Class } from '@/types/common';

// Components
import SmIcon from '@/components/common/SmIcon/SmIcon.vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'SmNotify',
  props: {
    uuid: {},
    type: { default: 'neutral' },
    title: { default: '' },
    text: {},
    delay: { default: 6000 },
    allowHTML: { type: Boolean, default: false },
    modelValue: { type: Boolean, default: undefined },
    closable: { type: Boolean, default: true }
  },
  emits: ["update:modelValue"],
  setup(__props: any, { emit: __emit }) {

// Vue
const props = __props;

const emit = __emit;

const {
  type,
  title,
  text,
  delay,
  allowHTML,
  modelValue,
} = toRefs(props);

const internalVisible = ref<boolean>(false);

const isControlled = computed(() => modelValue.value !== undefined);

const isVisible = computed<boolean>({
  get: (): boolean => {
    return isControlled.value
      ? !!modelValue.value
      : internalVisible.value;
  },

  set: (value: boolean): void => {
    if (isControlled.value) {
      emit('update:modelValue', value);
      return;
    }

    internalVisible.value = value;
  },
});

const iconNames: Record<string, string> = {
  success: 'Success',
  warning: 'Warning',
  error: 'Error',
  info: 'Info'
};

const iconName = computed((): string => iconNames[type.value] || iconNames.info);

const iconClassList = computed((): Class => {
  return `sm-notify__icon--${type.value}`;
});

const contentClassList = computed((): Class => {
  return [
    'sm-notify__content',
    !title.value ? 'sm-notify__content--inline' : ''
  ].filter(item => item);
});

const close = (): void => {
  isVisible.value = false;
};


let timer: ReturnType<typeof setTimeout> | null = null;


onMounted(() => {
  if (isControlled.value) return;

  isVisible.value = true;

  if (delay.value > 0) {
    timer = setTimeout(() => {
      close();
    }, delay.value);
  }
});

onUnmounted(() => {
  if (timer) clearTimeout(timer);
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_Transition, { name: "sm-notify-animate" }, {
    default: _withCtx(() => [
      _withDirectives(_createElementVNode("div", _hoisted_1, [
        _createVNode(SmIcon, {
          name: iconName.value,
          size: 24,
          class: _normalizeClass(["sm-notify__icon", iconClassList.value])
        }, null, 8, ["name", "class"]),
        _createElementVNode("div", {
          class: _normalizeClass(contentClassList.value)
        }, [
          _createElementVNode("header", _hoisted_2, [
            (_unref(title))
              ? (_openBlock(), _createElementBlock("h3", _hoisted_3, _toDisplayString(_unref(title)), 1))
              : _createCommentVNode("", true),
            (_ctx.closable)
              ? (_openBlock(), _createBlock(SmIcon, {
                  key: 1,
                  name: "Cancel",
                  size: 16,
                  class: "sm-notify__close",
                  onClick: close
                }))
              : _createCommentVNode("", true)
          ]),
          (_unref(allowHTML))
            ? (_openBlock(), _createElementBlock("div", {
                key: 0,
                innerHTML: _unref(text),
                class: "sm-notify__text"
              }, null, 8, _hoisted_4))
            : (_openBlock(), _createElementBlock("p", _hoisted_5, _toDisplayString(_unref(text)), 1))
        ], 2)
      ], 512), [
        [_vShow, isVisible.value]
      ])
    ]),
    _: 1
  }))
}
}

})